export default "__VITE_ASSET__e1f4bcf9__"